import _cache from "../utils/_cache"
import _cache_key from "./_cache_key";

let cache_city = {
    key: _cache_key.city_name,

    set: function (v) {
        _cache.local_set(this.key, v);
    },

    get: function () {
        return _cache.local_get(this.key);
    },

    has: function () {
        return _cache.local_has(this.key);
    },

    empty: function () {
        return _cache.local_empty(this.key);
    }
};

//导出
export default cache_city
